import type { ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@material-ui/core/Link';

/** Internal routes use the router, absolute URLs open in a new tab. */
export function AppLink({
  to,
  children,
  ...rest
}: {
  to: string;
  children: ReactNode;
  'aria-label'?: string;
}) {
  if (/^(https?:)?\/\//.test(to)) {
    return (
      <Link href={to} target="_blank" rel="noopener noreferrer" {...rest}>
        {children}
      </Link>
    );
  }
  return (
    <Link component={RouterLink} to={to} {...rest}>
      {children}
    </Link>
  );
}
